import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d18f72a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "text ml10" }
const _hoisted_3 = { class: "hints" }

import { ref } from 'vue'
import { CloseOutlined } from '@ant-design/icons-vue'

interface Props {
  closeable: boolean
  title: string
  // primary|warning|danger|success|info
  type: string
  // block|inline
  mode: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'alert',
  props: {
    closeable: { type: Boolean, default: false },
    title: { default: '提示' },
    type: { default: 'primary' },
    mode: { default: 'block' }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const show = ref(true)
const backgrounds = {
  primary: '#E6F4FF',
  warning: '#FFFBE6',
  danger: '#FFF1F0',
  success: '',
  info: '',
}
const borderColor = ref(`--xn-${props.type}`)
if(props.type == 'danger') {
  borderColor.value = '--xn-error'
}
const backgroundColor = ref(backgrounds[props.type] || backgrounds.primary)

const title = ref()
if (props.title) {
  title.value = props.title
} else {
  ['primary', 'success'].includes(props.type) && (props.title = '提示');
  ['warning', 'danger'].includes(props.type) && (props.title = '警告');
  ['info'].includes(props.type) && (props.title = '帮助')
}

const close = () => {
  show.value = false
  emit('close')
}


return (_ctx: any,_cache: any) => {
  const _component_xn_icon = _resolveComponent("xn-icon")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "alert-info",
        style: _normalizeStyle(`
      border-left-color: var(${borderColor.value});
      background-color: ${backgroundColor.value};
    `)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.mode)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_xn_icon, {
              icon: `alert_${_ctx.type}`,
              class: "icon"
            }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2),
        (_ctx.closeable)
          ? (_openBlock(), _createBlock(_unref(CloseOutlined), {
              key: 0,
              class: "close-icon",
              onClick: close
            }))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}
}

})